import React, {useCallback} from 'react';
import {Link, useSearchParams} from 'react-router-dom';
import "./style.scss";


export const UnauthorizedView = () => {

    const [searchParams, setSearchParams] = useSearchParams();

    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams)
            params.set(name, value)

            return params.toString()
        },
        [searchParams]
    )

    return (
        <div className="error-view-container">
            <div className="error-view">
                <div className="error-view-code">
                    <h1>401</h1>
                </div>
                <h2 className="error-view-header">Вы не авторизованы</h2>
                <p className="error-view-content">
                    Страница, которую вы ищете, защищена от несанкционированного доступа.
                    <br></br>
                    Для доступа к контенту выполните <Link reloadDocument to={"/auth/login?" + createQueryString('requestedPage', (searchParams.get('requestedPage') ?? "/"))} >вход</Link>
                </p>
            </div>
        </div>
    )
};